<header class="header">
      <div class="header-grp">
            <div class="icon" (click)="goBackToPrevPage()">
                  <i class="ti ti-chevron-left"></i>
            </div>
            <div class="title">
                  <h3 *ngIf="action == 'Add'">પેટા કાર્યક્રમ ઉમેરો</h3>
                  <h3 *ngIf="action ==  'Edit'">પેટા કાર્યક્રમ બદલો</h3>
            </div>
      </div>
</header>
<main>
      <div class="profile-details">
            <div class="profile-form">
                  <form [formGroup]="subEventForm">
                        <div class="form-group">
                              <div class="form-group">
                                    <input type="text" class="form-control" placeholder="પેટા કાર્યક્રમ"
                                          formControlName="sub_event_name" />
                                    <div *ngIf="submitted && f.sub_event_name.errors" class="error-message">
                                          <small *ngIf="f.sub_event_name.errors?.required" class="text-danger">પેટા
                                                કાર્યક્રમ નામ જરૂરી
                                                છે.</small>
                                    </div>
                              </div>
                        </div>

                        <div class="form-group">
                              <mat-form-field class="example-full-width w-100" appearance="outline">
                                    <div class="d-flex">
                                          <input matInput [matDatepicker]="picker" placeholder="પ્રારંભ તારીખ"
                                                formControlName="from_date">
                                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                          <mat-datepicker #picker></mat-datepicker>
                                    </div>
                              </mat-form-field>
                              <div *ngIf="submitted && f.from_date.errors" class="error-message">
                                    <small *ngIf="f.from_date.errors?.required" class="text-danger">પ્રારંભ તારીખ
                                          જરૂરી
                                          છે.</small>
                              </div>
                        </div>

                        <div class="form-group">
                              <mat-form-field class="example-full-width w-100" appearance="outline">
                                    <div class="d-flex">
                                          <input matInput [matDatepicker]="picker1" placeholder="અંતિમ તારીખ"
                                                formControlName="to_date">
                                          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                          <mat-datepicker #picker1></mat-datepicker>
                                    </div>
                              </mat-form-field>
                              <div *ngIf="submitted && f.to_date.errors" class="error-message">
                                    <small *ngIf="f.to_date.errors?.required" class="text-danger">અંતિમ તારીખ
                                          જરૂરી
                                          છે.</small>
                              </div>
                        </div>

                        <button type="submit" class="btn-common" (click)="submit()">સાચવો</button>
                  </form>
            </div>
      </div>
</main>